import type { RecommendedResearchItem } from 'components/discover/research/model';
import type { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface RecommendedResearchApi {
  fetchRecommendedResearch(): Observable<RecommendedResearchItem[]>;
}

export type ResearchApi = RecommendedResearchApi;

export function researchConnector(httpClient: IHttpClient, timeoutInMillis = 30000): ResearchApi {
  return {
    fetchRecommendedResearch(): Observable<RecommendedResearchItem[]> {
      return httpClient
        .getJSON<{ items: RecommendedResearchItem[] }>({
          url: 'api/v1/researches/recommended',
          targetHost: 'AdvisoryBridge',
        })
        .pipe(
          timeout(timeoutInMillis),
          map(r => r.payload.items),
        );
    },
  };
}
